import { handleImageUrl } from "@saas/components/src";
import { REFUND_STATUS, PAY_TYPE } from "@saas/components/src/constants";
import moment from "moment";
export default {
  props: {
    refundInfo: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      handleImageUrl,
      moment,
      payType: PAY_TYPE,
      refundStatus: REFUND_STATUS,
      replyResult: {
        1: "待机构处理",
        2: "退款完成",
        3: "退款失败",
      },
    };
  },
  methods: {
    formatPrice(val) {
      if (val) {
        return "￥" + (val / 100).toFixed(2);
      } else {
        return "-";
      }
    },
    showUseDetail(obj) {
      const data = { ...this.refundInfo, ...obj };
      this.$emit("showUseDetail", data);
    },
    showRefundDetail(obj) {
      obj.sub_order_list = obj.goods || [];
      this.$emit("showRefundDetail", obj);
    },
  },
};
